<template>
  <GoogleMap
    :api-key="api_key"
    style="width: 100%; height: 400px"
    :center="center"
    :zoom="12"
  >
    <Marker :options="markerOptions" />
  </GoogleMap>
</template>

<script>
import { defineComponent } from "vue";
import { GoogleMap, Marker } from "vue3-google-map";

export default defineComponent({
  components: { GoogleMap, Marker },
  props: {
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const center = { lat: Number(props.lat), lng: Number(props.lng) };
    const api_key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    const markerOptions = {
      position: center,
      label: "",
      title: props.title
    };

    return { center, markerOptions, api_key };
  }
});
</script>
